// chartEnums.js
// Shared enums for ChartView components

// Value type for the chart Y-axis
export const ValueType = {
  QUANTITY: 'quantity',
  CURRENCY: 'currency',
};

// Chart display modes
export const ChartMode = {
  YEARLY: 'yearly',
  YTD: 'ytd',
  YTD_ACCUMULATED: 'ytd_accumulated',
  WEEKLY: 'weekly',
};

// Predefined palette of 8 colors for the chart curves
export const CHART_COLORS = [
  'rgba(45, 114, 210, 1)', // Blue
  'rgba(210, 45, 45, 1)',  // Red
  'rgba(45, 210, 114, 1)', // Green
  'rgba(210, 160, 45, 1)', // Orange/Yellow
  'rgba(114, 45, 210, 1)', // Purple
  'rgba(210, 114, 45, 1)', // Orange
  'rgba(45, 210, 210, 1)', // Cyan
  'rgba(114, 210, 45, 1)', // Lime
];



// WEBPACK FOOTER //
// ./src/components/ChartView/chartEnums.js